var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 593 593",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 570 295 C 570 446 446 571 294 569 144 568 23 443 24 294 25 144 147 22 297 23 448 23 570 145 570 295 Z M 551 302 C 554 161 442 44 303 42 162 39 45 150 43 289 40 430 151 547 290 550 430 553 548 441 551 302 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 382 296 C 382 343 341 383 293 381 248 379 211 340 212 295 213 249 252 211 297 211 344 212 381 251 382 296 Z M 296 231 C 260 232 230 262 231 297 232 333 262 363 297 362 334 361 364 331 363 295 362 260 332 230 296 231 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 292 53 L 303 53 303 200 292 200 292 53 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 292 392 L 302 392 302 539 292 539 292 392 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 393 292 L 393 302 540 302 540 292 393 292 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 54 294 L 54 304 202 304 202 292 54 294 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 372 232 L 366 225 475 126 482 133 372 232 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 119 457 L 113 450 223 352 229 359 119 457 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 225 234 L 119 132 125 125 231 228 225 234 Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 469 470 L 363 368 369 361 475 463 469 470 Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 255 211 L 195 77 204 73 264 207 255 211 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 391 522 L 331 387 340 384 399 518 391 522 Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 342 211 L 333 207 396 74 405 78 342 211 Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 197 518 L 188 514 251 381 260 385 197 518 Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 388 266 L 385 257 522 203 525 212 388 266 Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 72 388 L 69 379 206 325 209 334 72 388 Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 206 268 L 68 217 72 207 209 259 206 268 Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 523 387 L 386 336 389 326 527 378 523 387 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelSet);
export default __webpack_public_path__ + "static/media/wheel-set.adad5237e99d45ee95e883ec7696b80c.svg";
export { ForwardRef as ReactComponent };